import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { DualAxis } from 'components/charts/DualAxis/DualAxis'
import { ViewersPageProps } from '../../../pages/viewers/ViewersPage/ViewersPage.types'
import { VIEWERS_STORE } from '../../../store'
import cl from 'classnames'
import styles from './ViewersChart.module.scss'
import moment from 'moment'
import { SectionContainer } from 'components/shared'
import { ChartHeader } from '../Header/Header'

const ViewersChartComponent = (props: ViewersPageProps) => {
  const {
    [VIEWERS_STORE]: {
      getViewersStats,
      viewerTotalStats,
      uniqueViewers,
      uniqueProjects,
      addExpenses,
      revenue,
      totalWatchTime,
      totalInteractionTime
    }
  } = props

  useEffect(getViewersStats, [getViewersStats])

  const totalWatchTimeLabel = moment.duration(totalWatchTime, 'milliseconds').format('hh:mm', { trim: false }) + 'h'
  const totalInteractionTimeLabel = moment.duration(totalInteractionTime, 'milliseconds').format('hh:mm', { trim: false }) + 'h'
  const addExpensesLabel = '$' + addExpenses
  const revenueLabel = '$' + revenue
  const sections: Map<string, string> = new Map([
    ['TOTAL WATCH TIME', totalWatchTimeLabel],
    ['TOTAL INTERACTION TIME', totalInteractionTimeLabel],
    ['AD EXPENSES', addExpensesLabel],
    ['PURCHASE REVENUE', revenueLabel]
  ])
  return (
    <SectionContainer className={cl(styles.unsetPosition)}>
      <ChartHeader
        projectsCount={uniqueProjects}
        total={'Total viewers: ' + uniqueViewers}
        sections={sections}
      />
      <DualAxis data = {viewerTotalStats}/>
    </SectionContainer>
  )
}

const ViewersChart = inject(VIEWERS_STORE)(observer(ViewersChartComponent))
export { ViewersChart }
